import React, { useState } from 'react';
import './App.css';
import Header from "./components/Header";
import ChatInput from "./components/ChatInput";
import ChatMessage from "./components/ChatMessage";
import ChatStatusIndicator from "./components/ChatStatusIndicator";
import Loading from "./components/Loading";
import { useThread } from './hooks/useThread';
import { useRunPolling } from './hooks/useRunPolling';
import { useRunRequiredActionsProcessing } from './hooks/useRunRequiredActionsProcessing';
import { useRunStatus } from './hooks/useRunStatus';
import { postMessage } from "./services/api";

function App() {
    const [run, setRun] = useState(undefined);
    const { threadId, messages, setActionMessages, clearThread } = useThread(run, setRun);
    useRunPolling(threadId, run, setRun);
    useRunRequiredActionsProcessing(run, setRun, setActionMessages);
    const { status, processing } = useRunStatus(run);

    // // Ensure we do not try to access properties of `run` if it is undefined
    // const currentThreadId = run?.thread_id;

    // // Display loading or error until threadId is available
    // if (!currentThreadId) {
    //     return <div>Loading thread...</div>;  // Placeholder for a loading state
    // }

    let messageList = messages
        .toReversed()
        .filter((message) => message.hidden !== true)
        .map((message) => (
            <ChatMessage
                message={message.content}
                role={message.role}
                key={message.id}
            />
        ));

    return (
        <div className="md:container md:mx-auto lg:px-32 h-screen bg-slate-700 flex flex-col">
            <Header onNewChat={clearThread} />
            <div className="flex flex-col-reverse grow overflow-auto">
                {status !== undefined && (
                    <ChatStatusIndicator status={status} />
                )}
                {processing && <Loading />}
                {messageList}
            </div>
            <div className="my-4">
                <ChatInput
                    onSend={(message) => {
                        // Only attempt to post message if threadId is defined
                        //if (currentThreadId) {
                            postMessage(threadId, message).then(setRun);
                        //}
                    }}
                    disabled={processing}
                />
            </div>
        </div>
    );
}

export default App;

